import { useState } from 'react';
import CookiePolicyModal from '@/components/feature/CookiePolicyModal';

export default function Footer() {
  const [isCookiePolicyOpen, setIsCookiePolicyOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
    <footer className="bg-dark text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Column 1 - Brand */}
          <div>
            <img 
              src="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/47a7fddbd826a7acacf456eebae06a13.png" 
              alt="Big Finance Srl Logo" 
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-gray-light/70 text-sm mb-6 leading-relaxed">
              Esperienze memorabili dal 2010. Leader nell'organizzazione di eventi corporate, marketing strategico e motorsport di alto livello in Italia ed Europa.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-primary hover:text-primary transition-all"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-primary hover:text-primary transition-all"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-primary hover:text-primary transition-all"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Services */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase mb-6">Servizi</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('servizi')}
                  className="text-gray-light/70 hover:text-primary transition-colors text-sm whitespace-nowrap"
                >
                  Eventi Corporate
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('eventi')}
                  className="text-gray-light/70 hover:text-primary transition-colors text-sm whitespace-nowrap"
                >
                  Motorsport
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('marketing')}
                  className="text-gray-light/70 hover:text-primary transition-colors text-sm whitespace-nowrap"
                >
                  Marketing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servizi')}
                  className="text-gray-light/70 hover:text-primary transition-colors text-sm whitespace-nowrap"
                >
                  Ricerche di Mercato
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servizi')}
                  className="text-gray-light/70 hover:text-primary transition-colors text-sm whitespace-nowrap"
                >
                  Pubblicità
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h3 className="text-white font-bold text-sm uppercase mb-6">Contatti</h3>
            <div className="space-y-4">
              <div className="flex gap-3">
                <i className="ri-map-pin-line text-primary text-lg flex-shrink-0"></i>
                <div className="text-gray-light/70 text-sm">
                  Via Antonio Chinotto 1<br />
                  00195 Roma (RM), Italia
                </div>
              </div>
              <div className="flex gap-3">
                <i className="ri-mail-line text-primary text-lg flex-shrink-0"></i>
                <a
                  href="mailto:bigfinancesrl@gmail.com"
                  className="text-gray-light/70 hover:text-primary transition-colors text-sm"
                >
                  bigfinancesrl@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-light/60">
            <div>
              © 2025 BIG FINANCE S.R.L. Tutti i diritti riservati
            </div>
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-primary transition-colors whitespace-nowrap">
                Privacy Policy
              </a>
              <span>•</span>
              <button
                type="button"
                onClick={() => setIsCookiePolicyOpen(true)}
                className="hover:text-primary transition-colors whitespace-nowrap cursor-pointer"
              >
                Cookie Policy
              </button>
              <span>•</span>
              <span className="whitespace-nowrap">P.IVA IT-06146231003</span>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <CookiePolicyModal isOpen={isCookiePolicyOpen} onClose={() => setIsCookiePolicyOpen(false)} />
    </>
  );
}